import math from "./math";

export default function (av_ins) {
  if (av_ins.grade_field !== "CONTA" && av_ins.fields) {
    const f_title = av_ins.grade_field;
    let field = av_ins.fields.filter((f) => f.title === f_title);
    if (field.length > 0) return field[0].input;
  }
  return math(av_ins).toFixed(2);
}
